import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Redirect, Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

import PageTitle from '../../../components/PageTitle/PageTitle';
import { loadResource, deleteResource } from '../../../redux/modules/resources';

class ResourceDelete extends Component<{}> {
    componentDidMount() {
        const resourceId = this.props.match.params.resourceId;
        // Load resources on component mount
        this.props.dispatchLoadResource(resourceId);
    }

    deleteResource(resourceId) {
        this.props.dispatchDeleteResource(resourceId);
    }

    render() {
        const { t }                                                = this.props;
        const { resource, isLoading, resourceSuccessfullyDeleted } = this.props.resources;

        let title = <span>{t("resources.resource", {count: 42})}</span>;
        if (resource)
            title = (
                <span>
                    {t("resources.resource", {count: 1})}
                    <small> | { resource.number } </small>
                </span>
            );

        const actions =
        <div>
            <ButtonGroup>
                <Button tag={Link} to="/resources" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t("common.back")}
                </Button>
            </ButtonGroup>
        </div>

        return (
            <div className="ResourceDelete">
                <PageTitle icon="key" title={ title } actions={ actions } />

                {resourceSuccessfullyDeleted &&
                    <Redirect to="/resources"/>
                }

                {resource &&
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <CardTitle><i className="fa fa-warning"></i>&nbsp;{t('resources.confirm_delete')}</CardTitle>
                                    <CardText tag="div">
                                        <div><strong>{t("resources.number")}</strong>: {resource.number}</div>
                                        <div><strong>{t("resources.type")}</strong>: {resource.type}</div>
                                        {resource.user &&
                                            <div><strong>{t("resources.user")}</strong>: {`${resource.user.firstname} ${resource.user.lastname}`}</div>
                                        }
                                        <div><strong>{t("resources.comment")}</strong>: {resource.comment}</div>
                                        <Row>
                                            <Col className="text-center">
                                                <Button tag={Link} to="/resources" color="warning">
                                                    <i className="fa fa-arrow-left"></i>&nbsp;{ t('common.cancel')}
                                                </Button>&nbsp;
                                                <Button color="danger" onClick={(e) => this.deleteResource(resource.id)} disabled={isLoading}>
                                                    {isLoading ?
                                                        <span>
                                                            &nbsp;<i className="fa fa-spinner fa-spin"></i>
                                                        </span>
                                                        :
                                                        <span>
                                                            <i className="fa fa-trash"></i>&nbsp;
                                                            { t('common.delete')}
                                                        </span>
                                                    }
                                                </Button>
                                            </Col>
                                        </Row>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                }
            </div>
        );
    }
}

const mapDispatchToProps = {
    dispatchLoadResource: (resourceId) => loadResource(resourceId),
    dispatchDeleteResource: (resourceId) => deleteResource(resourceId)
}

const mapStateToProps = state => ({
    resources: state.resources
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(ResourceDelete))
